import React from 'react';
import { HStack, Flex } from '@cad-arc';
import { FrPageBody } from '../../fr-page-layout/fr-page-body';
import { EVENT_SUMMARY_SECTION_WIDTH } from '../../fr-event-common-components/constants';
import { EventNarrative } from '../../event-narrative';
import { FrEventSummary } from '../../fr-event-common-components/fr-event-summary';
import { useOpenFrEventDetails } from '../../fr-event-details-page/hooks/use-open-fr-event-details';
import { FR_EVENT_DETAILS_TABS } from '../../fr-event-details-page/constants';
import { EventAdditionalInfosWrapper } from '../../additional-infos/event-panel-additional-infos/event-additional-infos-wrapper';

export function FrAssignedEventPageBody() {
    const openFrEventDetails = useOpenFrEventDetails();

    const onOpenFrEventDetails = (eventId: number) => {
        openFrEventDetails(eventId, FR_EVENT_DETAILS_TABS.EVENT_INFO);
    };
    return (
        <FrPageBody>
            <HStack h="100%" w="100%">
                <Flex
                    width={`calc(100% - ${EVENT_SUMMARY_SECTION_WIDTH})`}
                    height="100%"
                    justifyContent="center"
                    alignItems="center"
                >
                    <EventAdditionalInfosWrapper>
                        <EventNarrative onOpenEvent={onOpenFrEventDetails} />
                    </EventAdditionalInfosWrapper>
                </Flex>
                <FrEventSummary />
            </HStack>
        </FrPageBody>
    );
}
